module.exports = __webpack_public_path__ + "static/img/预约挂号@3x.05dc9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/预约挂号@3x.png
// module id = 323
// module chunks = 379 380